import api from "./core";

const basePath = "api/{{serverSegment}}/PatientRequestDocuments";

export default {
  get(id) {
    return api.get(`${basePath}/${id}`);
  },
  create(data) {
    return api.put(basePath, data);
  },
  update(id, data) {
    return api.put(`${basePath}/${id}`, data);
  }
};
